import React from 'react';

const RefundMoneyPage = () => {
  return <div>RefundMoneyPage</div>;
};

export default RefundMoneyPage;
